import { Help } from '@mui/icons-material'
import { ButtonBase, Stack, Typography } from '@mui/material'
import I18n from 'i18n-js'

import AppConfig from '@src/config/AppConfig'
import { useFeatureFlag } from '@src/lib/useFeatureFlag'

const FloatingSupportButton: React.FC = () => {
  const searchParams = new URLSearchParams(window.location.search)
  const onlyContent = searchParams.get('onlyContent') === 'true'
  const isEnabled = useFeatureFlag('diy-support-button')

  if (!isEnabled || onlyContent || !AppConfig.ZENDESK_WEB_WIDGET_ID) {
    return null
  }

  return (
    <>
      <ButtonBase
        sx={(theme) => ({
          'position': 'fixed',
          'bottom': theme.spacing(2),
          'right': 0,
          'zIndex': theme.zIndex.modal - 1,

          'borderRadius': 1,
          'borderTopRightRadius': 0,
          'borderBottomRightRadius': 0,

          'backgroundColor': theme.palette.discovery.dark,
          'color': theme.palette.discovery.contrastText,
          'boxShadow': 4,

          'writingMode': 'sideways-lr',
          'paddingX': 2,
          'paddingY': 4,

          '&:hover': {
            backgroundColor: theme.palette.discovery.main,
            boxShadow: 8,
          },
        })}
        onClick={() => {
          const isOpen = Boolean(document.querySelector('#webWidget'))

          if (isOpen) {
            window.zE?.hide()
          } else {
            window.zE?.activate()
          }
        }}
      >
        <Stack direction="row" alignItems="center" spacing={2}>
          <Help
            sx={{
              transform: 'rotate(-90deg)',
            }}
          />

          <Typography variant="h6">{I18n.t('shared.support')}</Typography>
        </Stack>
      </ButtonBase>
    </>
  )
}

export default FloatingSupportButton
